"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomUuid = exports.randomUrl = exports.randomPhoneNumber = exports.randomInteger = exports.randomEmail = exports.randomString = exports.randomDate = exports.randomBuffer = exports.randomBoolean = void 0;
const node_crypto_1 = require("node:crypto");
const DAYS_IN_WEEK = 7;
function cryptoRandomSync(byteSize) {
    return (0, node_crypto_1.randomBytes)(byteSize).toString("hex");
}
/**
 * These random numbers are not cryptographically secure. If you need security
 * or are in doubt, use `crypto.getRandomValues()` or `crypto.randomBytes()`.
 */
function unsafeRandom() {
    return Math.random();
}
/** Create a random boolean. */
function randomBoolean() {
    return unsafeRandom() < 0.5;
}
exports.randomBoolean = randomBoolean;
/** Create a random buffer. */
function randomBuffer(n = 10) {
    return (0, node_crypto_1.randomBytes)(n);
}
exports.randomBuffer = randomBuffer;
/** Create a random date between "start" and "end". */
function randomDate(start = new Date(new Date().setDate(new Date().getDate() - DAYS_IN_WEEK)), end = new Date()) {
    return new Date(start.getTime() + unsafeRandom() * (end.getTime() - start.getTime()));
}
exports.randomDate = randomDate;
/** Create a random string of the specified length. */
function randomString(length = 10) {
    return cryptoRandomSync(length).slice(0, Math.max(0, length));
}
exports.randomString = randomString;
/** Create a random email. */
function randomEmail() {
    return `${randomString()}@${randomString()}.com`;
}
exports.randomEmail = randomEmail;
/**
 * Create a random integer between "minimum" (inclusive) and "maximum" (inclusive).
 */
function randomInteger(minimum = 0, maximum = 100) {
    const min = Math.ceil(minimum);
    const max = Math.floor(maximum);
    return Math.floor(unsafeRandom() * (max - min + 1)) + min;
}
exports.randomInteger = randomInteger;
/**
 * Creates a random US phone number that passes validation of libphonenumber-js.
 */
function randomPhoneNumber(options = {}) {
    const { international } = { international: false, ...options };
    const prefix = international ? "+1" : "";
    return `${prefix}650${randomInteger(2000000, 9999999)}`;
}
exports.randomPhoneNumber = randomPhoneNumber;
/** Create a random URL. */
function randomUrl() {
    return `https://${randomString()}.com`;
}
exports.randomUrl = randomUrl;
/** Create a random UUID. */
function randomUuid() {
    return (0, node_crypto_1.randomUUID)();
}
exports.randomUuid = randomUuid;
//# sourceMappingURL=random.js.map